/**
 * VB New - Intro y video
 * Escritorio: el video (snippet video-player) arranca en silencio y en loop;
 * "Vívelo" lo reinicia con audio usando el botón del snippet, así sus estados
 * (íconos, audio, aria-label) se mantienen sincronizados.
 * Móvil: el video no se muestra en la página; "Vívelo" lo abre en pantalla completa.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileQuery = window.matchMedia('(max-width: 768px)');

  function init(root) {
    if (!root || root.dataset.vbnReady) return;
    root.dataset.vbnReady = 'true';

    var player = root.querySelector('[data-vp]');
    if (!player) return;

    var video = player.querySelector('[data-vp-video]');
    var playButton = player.querySelector('[data-vp-btn]');
    var wrap = root.querySelector('[data-vbn-video-wrap]');
    var closeButton = root.querySelector('[data-vbn-video-close]');
    var triggers = root.querySelectorAll('[data-vbn-video-play]');
    var lastTrigger = null;
    if (!video) return;

    // Sincroniza el estado visual del snippet (botón oculto y label de pausa/play)
    function setPlayingState(isPlaying) {
      player.classList.toggle('is-playing', isPlaying);
      if (playButton) {
        var label = playButton.getAttribute(isPlaying ? 'data-vp-label-pause' : 'data-vp-label-play');
        if (label) playButton.setAttribute('aria-label', label);
      }
    }

    // Autoplay en silencio solo en escritorio; el primer toque activa el sonido (lógica del snippet)
    if (!reduceMotion && !mobileQuery.matches) {
      video.muted = true;
      var autoplay = video.play();
      if (autoplay) {
        autoplay
          .then(function () {
            setPlayingState(true);
          })
          .catch(function (error) {
            console.log('[VBN Bento] Autoplay bloqueado:', error);
          });
      }
    }

    function playWithSound() {
      video.currentTime = 0;
      if (video.paused) {
        if (playButton) {
          playButton.click();
        } else {
          video.muted = false;
          video.play().catch(function () {});
        }
      } else {
        video.muted = false;
        setPlayingState(true);
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closeModal();
    }

    function openModal(trigger) {
      if (!wrap) return;
      lastTrigger = trigger;
      root.classList.add('is-video-open');
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      if (closeButton) closeButton.focus();
    }

    function closeModal() {
      if (!root.classList.contains('is-video-open')) return;
      root.classList.remove('is-video-open');
      wrap.removeAttribute('role');
      wrap.removeAttribute('aria-modal');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      video.pause();
      setPlayingState(false);
      if (lastTrigger) lastTrigger.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (mobileQuery.matches) openModal(trigger);
        playWithSound();
      });
    });

    if (closeButton) closeButton.addEventListener('click', closeModal);

    // Tocar el fondo oscuro (fuera del video) también cierra
    if (wrap) {
      wrap.addEventListener('click', function (event) {
        if (event.target === wrap) closeModal();
      });
    }

    console.log('[VBN Bento] Inicializado');
  }

  function initAll() {
    document.querySelectorAll('[data-vbn-bento]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-vbn-bento]'));
  });
})();
